import React from "react";
import { Box, Container, Typography, Grid, Stack } from "@mui/material";
import { motion } from "framer-motion";
import { PlayCircleOutline } from "@mui/icons-material";

const MotionBox = motion(Box);

const VideoSection: React.FC = () => {
  return (
    <Box
      id="video-section"
      sx={{
        py: { xs: 10, md: 14 },
        background: "linear-gradient(135deg, #042E4B 0%, #0a4a6e 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative Elements */}
      <Box
        sx={{
          position: "absolute",
          top: -200,
          right: -200,
          width: 500,
          height: 500,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(239,68,60,0.1) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Video */}
          <Grid size={{ xs: 12, lg: 7 }}>
            <MotionBox
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0 32px 64px rgba(0,0,0,0.3)",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 4,
                    background:
                      "linear-gradient(90deg, #EF443C 0%, #ff6b5b 100%)",
                    zIndex: 1,
                  },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    paddingTop: "56.25%", // 16:9 aspect ratio
                    backgroundColor: "#000",
                  }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/1EwsC6QOWBE"
                    title="ThinkWay - Demonstração"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                </Box>
              </Box>
            </MotionBox>
          </Grid>

          {/* Content */}
          <Grid size={{ xs: 12, lg: 5 }}>
            <MotionBox
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Stack spacing={3}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#EF443C",
                  }}
                >
                  <PlayCircleOutline />
                  <Typography
                    variant="overline"
                    sx={{ fontWeight: 600, letterSpacing: 2 }}
                  >
                    Vídeo Demonstrativo
                  </Typography>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    color: "white",
                    fontWeight: 800,
                    fontSize: { xs: "1.75rem", md: "2.25rem" },
                    lineHeight: 1.3,
                  }}
                >
                  Veja como podemos{" "}
                  <Box component="span" sx={{ color: "#EF443C" }}>
                    transformar
                  </Box>{" "}
                  seu planejamento
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    lineHeight: 1.8,
                    fontSize: "1.1rem",
                  }}
                >
                  Com a nossa plataforma, você terá acesso a ferramentas
                  avançadas que facilitam a definição de metas claras e o
                  monitoramento em tempo real do progresso da sua estratégia.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    lineHeight: 1.8,
                    fontSize: "1.1rem",
                  }}
                >
                  O <strong>ThinkWay</strong> foi projetado de maneira intuitiva
                  para simplificar processos complexos, permitindo que sua
                  equipe se concentre no que realmente importa:{" "}
                  <strong>impulsionar os resultados</strong>.
                </Typography>

                <Box sx={{ pt: 2 }}>
                  <Stack direction="row" spacing={4} flexWrap="wrap" sx={{ gap: 2 }}>
                    {[
                      { value: "37+", label: "Funcionalidades" },
                      { value: "5", label: "Recursos de IA" },
                      { value: "24/7", label: "Disponibilidade" },
                    ].map((stat) => (
                      <Box key={stat.label}>
                        <Typography
                          variant="h4"
                          sx={{
                            color: "#EF443C",
                            fontWeight: 800,
                          }}
                        >
                          {stat.value}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontWeight: 500,
                          }}
                        >
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </MotionBox>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default VideoSection;
